/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />
import * as React from "react";
import { HtmlDocumentGenerator } from "TestManagement/Scripts/TFS.TestManagement.HtmlDocumentGenerator";
import { TreeNode } from "VSS/Controls/TreeView";
import { registerLWPComponent } from "VSS/LWP";
import TestsOM = require("TestManagement/Scripts/TFS.TestManagement");
import TCMConstants = require("Presentation/Scripts/TFS/Generated/TFS.TestManagement.Constants");
import { TestPlan } from "TFS/TestManagement/Contracts";

export interface ExportHTMLDialogProps {
    currentPlan: TestPlan;
    id: number;
    revision: number;
    title: string;
    childSuiteIds: number[];
    pointCount: number;
    type: TCMConstants.TestSuiteType;
    requirementId: number;
    parentSuiteId: number;
    queryText: string;
    status: string;
    totalPointCount: number;
    configurations: number[];
    isChildSuitesCountExceededForExportFeature: boolean;
    rootSuite: any;
    savedColumns: TestsOM.ITestPointGridDisplayColumn[];
}

// This is a proxy component for export HTML dialog
class ExportHTMLDialogProxy extends React.Component<ExportHTMLDialogProps, {}> {
    private _rootNode: TreeNode = TreeNode.create("root");

    private _launchExportHtmlDialog(parentSuite, plan) {
        let exportHtmlWindow = new HtmlDocumentGenerator({ columnOptions: this.props.savedColumns, plan: plan, suiteHierarchy: this._rootNode });
        exportHtmlWindow.launchExportHtmlDialog(parentSuite, this.props.isChildSuitesCountExceededForExportFeature);
    }

    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let suite: TestsOM.ITestSuiteModel = {
            id: this.props.id,
            revision: this.props.revision,
            title: this.props.title,
            childSuiteIds: this.props.childSuiteIds,
            // Filtered/Visible points in a suite
            pointCount: this.props.pointCount,
            type: this.props.type,
            requirementId: this.props.requirementId,
            parentSuiteId: this.props.parentSuiteId,
            queryText: this.props.queryText,
            status: this.props.status,
            //Total Points in a suite
            totalPointCount: this.props.totalPointCount,
            configurations: this.props.configurations
        };

        this.createSuiteTree(this.props.rootSuite, this._rootNode, 0);
        let plan: any = {
            plan: this.props.currentPlan
        };
        plan.plan.rootSuiteId = this.props.rootSuite.id;

        this._launchExportHtmlDialog(suite, plan);
    }

    public createSuiteTree(currentSuite, currentNode, indexOfChild) {
        let nextChild = TreeNode.create(currentSuite.name);

        currentNode.children.push(nextChild);
        currentNode.children[indexOfChild].suite = currentSuite;

        let children = currentSuite.children;
        let childrenLength: number = 0;

        if (children) {
            childrenLength = children.length;
        }

        for (let i = 0; i < childrenLength; i++) {
            this.createSuiteTree(currentSuite.children[i], currentNode.children[indexOfChild], i);
        }
    }
}
registerLWPComponent("export-html-dialog-proxy", ExportHTMLDialogProxy);
